import { Box } from '@mui/material'
import MonetaryFormat from '../MonetaryFormat'
import { IPrintTotalPriceProps } from './interface'
import { useCustomerFacingDisplayContext } from 'pages/CustomerFacingDisplayPage/context/CustomerFacingDisplayProvider'

export function PrintTotalPrice({ subTotal, netTotal }: IPrintTotalPriceProps) {
    const {
        operationalSetting: { currencyCode, language },
    } = useCustomerFacingDisplayContext()

    return subTotal ? (
        <Box
            sx={{
                display: 'flex',
            }}
        >
            {subTotal && netTotal !== subTotal && (
                <MonetaryFormat
                    sx={{
                        textDecoration: 'line-through',
                        mr: 1.5,
                    }}
                    color={'inherit'}
                    isAccounting
                    value={subTotal}
                    currencyCode={currencyCode ?? 'USD'}
                    language={language ?? 'en'}
                />
            )}

            <MonetaryFormat
                color={'inherit'}
                isAccounting
                value={netTotal}
                currencyCode={currencyCode ?? 'USD'}
                language={language ?? 'en'}
            />
        </Box>
    ) : null
}
